import { BasePair } from '../../types';

export class LinksDataProcessor {
  /**
   * Generate base pair links from secondary structure consensus
   */
  static generateBasePairLinks(consensus: string): BasePair[] {
    const basePairs: BasePair[] = [];
    const openBrackets: number[] = [];
    
    // Start positions from 2 instead of 1 to leave position 1 as buffer
    const positionOffset = 1;
    
    for (let i = 0; i < consensus.length; i++) {
      const char = consensus[i];
      const position = i + 1 + positionOffset; // Convert to 1-based position + buffer offset
      
      if (char === '<') {
        openBrackets.push(position);
      } else if (char === '>') {
        const openPos = openBrackets.pop();
        if (openPos !== undefined) {
          const basePair: BasePair = {
            x: openPos,
            y: position,
            score: 1
          };
          basePairs.push(basePair);
        }
      }
    }
    
    // Always add buffer base pair at position 1
    if (basePairs.length > 0) {
      const bufferPair: BasePair = {
        x: 1,
        y: 2,
        score: 0.9999824 // High score like in the example
      };
      basePairs.unshift(bufferPair); // Add at the beginning
    }
    
    return basePairs;
  }

  /**
   * Format base pairs for nightingale-links component based on the source code
   */
  static formatForNightingale(basePairs: BasePair[]): any[] {
    // Always add base pair at position 1 if we have base pairs

      const initialPair: BasePair = {
        x: 1,
        y: 2,
        score: 1
      }

      basePairs = [initialPair, ...basePairs];

    // Format 1: String format (what nightingale-links expects)
    // Each line should be: "position1 position2 probability"
    const stringFormat = basePairs
      .map(bp => `${bp.x} ${bp.y} ${bp.score}`)
      .join('\n');

    // Format 2: Array format (alternative)
    const arrayFormat = basePairs.map(bp => [bp.x, bp.y, bp.score]);

    // Format 3: Direct contact object (if we want to bypass the parser)
    const contactObject = {
      contacts: {},
      maxNumberOfContacts: 1
    };
    
    // Build contacts object
    basePairs.forEach(bp => {
      if (!(contactObject.contacts as any)[bp.x]) {
        (contactObject.contacts as any)[bp.x] = new Set();
      }
      if (!(contactObject.contacts as any)[bp.y]) {
        (contactObject.contacts as any)[bp.y] = new Set();
      }
      (contactObject.contacts as any)[bp.x].add(bp.y);
      (contactObject.contacts as any)[bp.y].add(bp.x);
    });

    return [
      stringFormat,
      arrayFormat,
      contactObject
    ];
  }
}